import {initMap, initMapCenter, initMapMarkerInfo, initMapMarkerAnimation} from './mapStyle.jsx'
import ImagesLoaded from 'imagesloaded'

function stripHTML(dirtyString) {
    return dirtyString.replace(/(<([^>]+)>)/ig, " ");
}

function simpleSearch(html, text) {
    html = stripHTML(html).toLowerCase()
    let pieces = text.toLowerCase().split(' ')
    return pieces.filter((piece) => html.indexOf(piece) !== -1).length == pieces.length
}

export default function ListBox($) {
    let markers = []
    let searchText = ''
    let activeIds = []
    let filters = {}
    let listMap = null
    let hasMap = $('#listbox-map').length > 0

    const filterClickCallback = $('#listbox').hasClass('monoclick') ? function (e) {
        e.preventDefault()
        $(this).parent().parent().find('a.active').removeClass('active');
        $(this).addClass('active');
        doFilter()
    } : function (e) {
        e.preventDefault()
        $(this).toggleClass('active')
        doFilter()
    }

    const updateBrowserState = $('#listbox').hasClass('monostate') ?
        function () {
        }
        : function () {
        window.history.replaceState("", "", getLocalFilterString());
    }

    function postloadImages() {
        $('li.active span.postload').each(function () {
            $(this).replaceWith($("<img />", {class: 'inLoading', src: $(this).data('src')}));
        })
    }

    function hideMap() {
        $('#listbox-map').hide()
    }

    if (hasMap) {
        let int = setInterval(() => {
            if (!window.googleMapsLoaded) return
            listMap = initMap('listbox-map')
            clearInterval(int)
        }, 300);
    }

    function showMap(alignWorld) {
        if (!hasMap) return;
        if (listMap == null) {
            setTimeout(() => showMap(alignWorld), 500)
            return
        }
        $('#listbox-map').show()
        markers.map((marker) => marker.setMap(null))
        markers = []
        setTimeout(() => {
            let bounds = new google.maps.LatLngBounds();
            $('.listbox-items li.active').each(function () {
                if ($(this).data('lat')) {
                    let pos = new google.maps.LatLng($(this).data('lat'), $(this).data('lng'))
                    bounds.extend(pos)
                    let marker = new google.maps.Marker({
                        position: pos,
                        map: listMap,
                        url: $(this).find('a').attr('href')
                    })
                    initMapMarkerAnimation(marker)
                    initMapMarkerInfo(listMap, marker, '<div class="mapbox">' + $(this).html() + '</div>')

                    markers.push(marker)
                }
            })
            initMapCenter(listMap, alignWorld ? null : bounds)
        }, 100)
    }

    function doFilter() {
        filters = []
        activeIds = []
        $('.listbox-filterbox.active a.active').each(function () {
            filters.push({
                key: $(this).closest('.listbox-filterbox').data('filter'),
                value: $(this).data('filter')
            })
        })
        filters = filters.reduce((carry, filter) => {
            if (!(filter.key in carry))
                carry[filter.key] = []
            carry[filter.key].push(filter.value)
            return carry
        }, {})
        $('.listbox-items li').each(function () {
            let valid = true
            let item = $(this)
            if (item.hasClass('header')) {
                return
            }
            for (let k in filters) {
                if (k == 'categories') {
                    valid = valid && item.attr('data-' + k)
                            .split(',')
                            .map((v) => (filters[k].indexOf(parseInt(v)) !== -1))
                            .reduce((curry, x) => x || curry, false)
                } else {
                    valid = valid && filters[k].indexOf(item.data(k)) !== -1
                }
            }
            if (searchText.length > 0) {
                valid = valid && simpleSearch($(this).html(), searchText)
            }
            item.toggleClass('active', valid)
            if (valid) {
                activeIds.push(item.data('id'))
            }
        })
        if ($('#listbox-modes a.active').data('mode') == 'map') {
            showMap(false)
        }
        updateBrowserState()
        postloadImages()
    }

    function getLocalFilterString() {
        let ret = '?' +
            ($('#listbox-modes a.active').length ? '&mode=' + $('#listbox-modes a.active').data('mode') : '')
            + (searchText ? '&s=' + encodeURI(searchText) : '')
            + (Object.keys(filters).reduce((carry, k) => {
                return carry + filters[k].reduce((carry2, val) => {
                        return carry2 + '&filters[' + k + '][]=' + encodeURI(val)
                    }, '')
            }, ''))
        return ret.length == 1 ? '' : ret.replace('?&', '?')
    }

    function getFilterString() {
        let modes = $('#listbox-modes a.active').length ? '&params[mode]=' + $('#listbox-modes a.active').data('mode') : ''
        return '?ids=' + activeIds.join(',')
            + modes
            + (searchText ? '&params[s]=' + encodeURI(searchText) : '')
            + Object.keys(filters).reduce((carry, k) => {
                return carry + filters[k].reduce((carry2, val) => {
                        return carry2 + '&params[filters][' + k + '][]=' + encodeURI(val)
                    }, '')
            }, '')
    }

    function doListboxAccordion() {
        function toggleListboxAccordion(o) {
            o.toggleClass('open')
            o.height(o.hasClass('open') ? o.find('> div').height() + 60 : 0)
        }

        $('#listbox.biblio.list a[data-lbaccordion]').click(function (e) {
            e.preventDefault()
            if (!$('li.accordion[data-lbaccordion="' + $(this).data('lbaccordion') + '"]').hasClass('open')) {
                $('.openlbaccordion').toggleClass('openlbaccordion')
                toggleListboxAccordion($('li.accordion.open'))
            }
            toggleListboxAccordion($('li.accordion[data-lbaccordion="' + $(this).data('lbaccordion') + '"]'))

            $('a[data-lbaccordion="' + $(this).data('lbaccordion') + '"] svg').toggleClass('openlbaccordion')
        })
    }


    $('#listbox-modes a').click(function (e) {
        e.preventDefault()
        let prev = $('#listbox-modes a.active').data('mode')
        let curr = $(this).data('mode')
        $('#listbox-modes a[data-mode="' + prev + '"]').removeClass('active')
        $('#listbox-modes a[data-mode="' + curr + '"]').addClass('active')
        $('#listbox').hide()
            .removeClass(prev)
            .addClass(curr)
            .delay(250)
            .fadeIn()
        if (curr == 'map') {
            showMap(true)
        } else {
            hideMap()
        }
    })
    $('#listbox-filters a').click(function (e) {
        e.preventDefault()
        let curr = $(this).data('filter')
        $(this).toggleClass('active')
        let isActive = $(this).hasClass('active')
        $('.listbox-filterbox[data-filter=' + curr + ']').toggleClass('active', isActive)
        if (!$(this).hasClass('active')) {
            $('.listbox-filterbox[data-filter=' + curr + '] a.active').removeClass('active')
            doFilter()
        }
    })
    $('.listbox-filterbox > a.close').click(function (e) {
        e.preventDefault()
        let f = $(this).parent().data('filter')
        $('#listbox-filters a[data-filter="' + f + '"]').click()
    })

    $('.listbox-filterbox > ul > li > a').click(filterClickCallback)

    $('.listbox-link').click(function (e) {
        // if (!$(this).attr('href')) return;
        e.preventDefault()
        window.location.href = $(this).attr('href') + getFilterString()
    });

    $('#listbox-search form').submit(function (e) {
        e.preventDefault()
        searchText = $(this).find('input').val()
        doFilter()
    }).submit(); //this runs a first search
    if (!$('#listbox-search form').length) {
        doFilter()
    }
    if ($('#listbox.biblio.list').length)
        doListboxAccordion()
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/listbox.jsx